import axiosAuth from '../../axios/auth';
var qs = require( 'qs' ); // necessary for stringifying json for http requests to API

import router from '../../router/router';
// vuex modules resources:
//  https://morningstar.engineering/managing-your-vue-js-applications-state-with-vuex-part-2-5e5c3a0cd507
//  https://stackoverflow.com/questions/46234832/structuring-a-vuex-module

const state = {

    isAuth             : localStorage.getItem( 'token' ) || null,
    profileInfo        : JSON.parse( localStorage.getItem( 'profile' ) ) || {},
    roles              : JSON.parse( localStorage.getItem( 'roles' ) ) || [],
    activeRole         : localStorage.getItem( 'activeRole' ) || null,
    authError          : null,
    profileUpdateError : null,
    sentCode           : JSON.parse( localStorage.getItem( 'sentCode' ) ) || false,
    phoneUser          : localStorage.getItem( 'phoneUser' ) || null,
    authViaPhone       : localStorage.getItem( 'authViaPhone' ) || null
};

const mutations = {

    authUser( state, userData ){

        console.log( 'user data: ', userData );
        let roleArr = [];
        let roles = userData.role.split( "," );
        roles.forEach( value => {

            roleArr.push( value.trim() );
            roleArr.sort();
        } );
        let profile = {

            userId      : userData.userId || null,
            merchantId  : userData.merchantId || null,
            user : {

                name       : userData.name || null,
                phone      : userData.phone || null,
                email      : userData.email || null,
                zip        : userData.zip || null,
                city       : userData.city || null,
                state      : userData.state || null,
                address    : userData.address || null,
                address2   : userData.address2 || null,
                country    : userData.country || null
            },
            profileImage   : userData.imagePath + userData.imageName || null,
            expressContact : {

                zipCode     : userData.contactZip || null,
                city        : userData.contactCity || null,
                state       : userData.contactState || null,
                address     : userData.contactAddress || null,
                birthDate   : userData.contactBirthDate || null,
                birthMonth  : userData.contactBirthMonth || null,
                gender      : userData.contactGender || null,
                firstName   : userData.contactFirstName || null,
                lastName    : userData.contactLastName || null,
                phoneNumber : userData.contactPhone || null,
                email       : userData.contactEmail || null,
                deleted     : userData.contactDeleted || null,
                joinDate    : userData.contactJoinDate || null,
                scrubbed    : userData.contactScrubbed || null,
                subscribed  : userData.contactSubscribed || null
            },
            prepaidAccount : {

                prepaidAccountBalance : Math.floor( userData.prepaidAccountBalance ) || null,
                prepaidAccountStatus  : userData.prepaidAccountStatus || null
            },
            cardDetails : {

                cardLast4   : userData.cardLast4 || null,
                cardNetwork : userData.cardNetwork || null
            }
        };

        switch( userData.cardNetwork ){

            case "VISA":

                profile.cardDetails.cardImage = 'visa.png';
                break;
            case "MSTR":

                profile.cardDetails.cardImage = 'mscard.png';
                break;
            case "AMEX":

                profile.cardDetails.cardImage = 'amcard.png';
                break;
            default:

                profile.cardDetails.cardImage = 'https://via.placeholder.com/35x21';
                break;
        }

        state.profileInfo = profile;
        state.roles       = roleArr;
        state.activeRole  = roleArr[ 0 ];

        localStorage.setItem( 'profile', JSON.stringify( profile ) );
        localStorage.setItem( 'roles', JSON.stringify( roleArr ) );
        localStorage.setItem( 'activeRole', roleArr[ 0 ] );

        state.isAuth     = localStorage.getItem( 'token' );
        state.loginError = null;
    },
    switchRole( state, role ){

        localStorage.setItem( 'activeRole', role );
        state.activeRole = role;
    },
    setAuthError( state, message ){

        state.authError = message;
    },
    setPhoneUser( state, phone ){
        localStorage.setItem( 'phoneUser', phone );
        state.phoneUser = phone;
    },
    setAuthViaPhone( state, flatViaPhone ){
        localStorage.setItem( 'authViaPhone', flatViaPhone );
        state.authViaPhone = flatViaPhone;
    },
    logoutUser( state ){

        state.isAuth      = false;
        state.profileInfo = {};
        state.roles       = [];

        state.activeRole    = null;
        state.loginError    = null;
        state.topHeaderOpen = true;
        localStorage.clear(); // remove all items in local storage
    },
    attachJwt( state, jwt ){

        state.isAuth = jwt;
        localStorage.setItem( 'token', jwt );
    },
    updateProfile( state ){

        localStorage.setItem( 'profile', JSON.stringify( state.profileInfo ) );
    },
    profileUpdateError( state, err ){

        state.profileUpdateError = err;
    },
    sentCode( state ){

        state.sentCode = true;
        localStorage.setItem( 'sentCode', true );
    },
    revertCode( state ){

        state.sentCode = false;
        localStorage.setItem( 'sentCode', false );
    },
    clearState( state ){

        state.isAuth             = null;
        state.profileInfo        = {};
        state.roles              = [];
        state.activeRole         = null;
        state.authError          = null;
        state.profileUpdateError = null;
        state.sentCode           = false;

        localStorage.removeItem( 'token' );
        localStorage.removeItem( 'activeRole' );
        localStorage.removeItem( 'sentCode' );
    }
};

const actions = {

    phoneSignin( { commit }, data ){

        console.log( 'phone signin incoming data: ', data );
        axiosAuth({

            method: 'post',
            url: '/phoneAuth',
            data: qs.stringify( data )
        }).then( res => {

            console.log( 'the response: ', res.data );
            if( res.data.responseCode == 100 ){

                commit( 'sentCode' );
                localStorage.setItem( 'tempPhone', data.phone );
            } else {

                commit( 'setAuthError', res.data.message );
            }
        }).catch( err => {

            console.log( 'call rejected!', err );
            commit( 'setAuthError', 'Server Error!' );
        });
    },
    checkCode( { commit, dispatch }, data ){

        console.log( 'check code incoming data: ', data );
        axiosAuth({

            method: 'post',
            url: '/phoneAuth',
            data: qs.stringify( data )
        }).then( res => {

            if( res.data.responseCode == 100 ){

                commit( 'revertCode' );

                // localStorage.clear();
                //localStorage.removeItem( 'tempPhone' );
                commit( 'attachJwt', res.data.jwt );
                console.log('cart = ', localStorage.getItem( 'cart' ));
                if (localStorage.getItem( 'cart' ) != null) {
                    if ( localStorage.getItem( 'cart' ).length > 2 ) {
                        router.replace( { name : 'order-tab' } );
                    } else {
                        router.replace( { name : 'order-menu' } );
                    }
                } else {
                    router.replace( { name : 'home' } );
                }
                
            } else {

                commit( 'setAuthError', res.data.message );
            }
        }).catch( err => {

            console.log( 'call rejected!', err );
            commit( 'setAuthError', 'Server Error!' );
        });
    },
    outAuthMerchantCredentials ( { commit, dispatch }, data){
        console.log( 'outAuthMerchantCredentials: ', data );

        const merchantData = {

            merchantId : data.merchantId,
            slug       : data.slug,
            name       : data.name
        };

        console.log( 'post-merchantData: ', merchantData );

        dispatch( 'merchant/updateCurrentMerchant', merchantData, { root : true } );
   
        router.push({

            name : 'merchant-location',
            params : { slug : merchantData.slug }
        });
       
    },
    getMerchantCredentials( { commit, dispatch }, data ){

        console.log( 'check incoming data: ', data );
        axiosAuth({

            method: 'post',
            url: '/getQuickOrderMerchantCredentials',
            data: qs.stringify( data )
        }).then( res => {

            if( res.data.responseCode == 100 ){

                localStorage.clear();
                console.log( 'data jwt!', res.data.jwt );
                commit( 'attachJwt', res.data.jwt );

                // handles initializing 'currentMerchant'
                let base64Url = res.data.jwt.split( '.' )[ 1 ];
                let base64    = base64Url.replace( '-', '+' ).replace( '_', '/' );
                const data    = JSON.parse( window.atob( base64 ) );

                const merchantData = {

                    merchantId : data.merchantId,
                    slug       : data.slug,
                    name       : data.name,
                    timezone   : data.timezone
                };
                console.log( 'post-viewing data: ', merchantData );

                dispatch( 'merchant/updateCurrentMerchant', merchantData, { root : true } );
                commit( 'setAuthViaPhone', true );

                router.push({

                    name : 'home',
                    params : { slug : data.slug }
                });

            } else {

                commit( 'setAuthError', res.data.message );
            }
        }).catch( err => {

            console.log( 'call rejected!', err );
            commit( 'setAuthError', 'Server Error!' );
        });
    },
    phoneUser( { commit, dispatch }, data ){
        console.log( 'data: ', data );
        commit( 'setPhoneUser', data );
    },
    authViaPhone( { commit, dispatch }, data ){
        console.log( 'data: ', data );
        commit( 'setAuthViaPhone', data );
    },
    signout( { commit, dispatch } ){

        dispatch( 'clearIndexDb', null, { root: true } );
        dispatch( 'orderMenu/needsMenu', null, { root: true } );
        dispatch( 'orderTab/clearTab', null, { root: true } );
        dispatch( 'nav/closeOverflow', null, { root: true } );
        commit( 'logoutUser' );
        //localStorage.removeItem( 'phoneUser' );
        //localStorage.removeItem( 'merchants' );
        //localStorage.removeItem( 'token' );
        //router.replace( { name : 'signin' } );
        router.replace( { name : 'not-found' } );
    },
    signin( { dispatch } ){
        dispatch( 'nav/closeOverflow', null, { root: true } );
        router.replace( { name : 'signin' } );
    },
    switchRole( { commit }, role ){

        commit( 'switchRole', role );
    },
    authUsingJwt( { commit, dispatch }, jwt ){ // this is the initial local-storage attachment of the JWT.
        // the result of this is a forward to the home page where a call to grab 'initialize' the app will be made

        localStorage.clear();

        // handles 'isAuth'
        commit( 'attachJwt', jwt );

        // handles initializing 'currentMerchant'
        let base64Url = jwt.split( '.' )[ 1 ];
        let base64    = base64Url.replace( '-', '+' ).replace( '_', '/' );
        const data    = JSON.parse( window.atob( base64 ) );
        console.log( 'pre-viewing data: ', data );
        const merchantData = {

            merchantId : data.merchantId,
            slug       : data.slug,
            name       : data.name,
            timezone   : data.timezone
        };
        console.log( 'post-viewing data: ', merchantData );
        dispatch( 'merchant/updateCurrentMerchant', merchantData, { root : true } );
    },
    initApp( { commit, getters, rootGetters } ){ // this will grab many details necessary for the app to function properly ( listed within function block.. )
        // - user's details
        // - merchant details

        axiosAuth({

            method: 'post',
            url: '/jwtGrabUserDetails',
            data: qs.stringify( { merchantId : rootGetters[ 'merchant/currentMerchant' ].merchantId } ),
            headers: {

                'Content-Type' : 'application/x-www-form-urlencoded',
                'AuthType'     : 'JWT',
                'ApiKey'       : process.env.VUE_APP_API_KEY,
                'Token'        : localStorage.getItem( 'token' ) || null
            }
        }).then( res => {

            if( res.data.responseCode == 100 ){

                var base64Url = res.data.jwt.split( '.' )[ 1 ];
                var base64    = base64Url.replace( '-', '+' ).replace( '_', '/' );
                const data    = JSON.parse( window.atob( base64 ) );

                commit( 'authUser', data );
            } else throw res;
        }).catch( err => {

            console.log( 'login error!', err );
            commit( 'logoutUser' );
            commit( 'loginError', err );
            router.replace( { name : 'signin' } );
        });
    },
    saveProfileInfo( { commit, getters, rootGetters } ){

        const profileInfo = {

            contact    : getters.profileInfo.expressContact,
            user       : getters.profileInfo.user,
            merchantId : rootGetters[ 'merchant/currentMerchant' ].merchantId || null
        };

        axiosAuth({

            method: 'post',
            url: '/updateProfileInfo',
            data: qs.stringify( profileInfo ),
            headers: {

                'Content-Type' : 'application/x-www-form-urlencoded',
                'AuthType'     : 'JWT',
                'ApiKey'       : process.env.VUE_APP_API_KEY,
                'Token'        : localStorage.getItem( 'token' ) || null
            }
        }).then( res => {

            console.log( 'the response: ', res );
            if( res.data.responseCode == 100 ){

                commit( 'updateProfile' );
                commit( 'profileUpdateError', null );
            } else {

                commit( 'profileUpdateError', res.data.message );
            }
        }).catch( err => {

            console.log( 'update error!', err );
            commit( 'profileUpdateError', 'Server Error!' );
        });
    },
    setAuthError( { commit }, data ){

        commit( 'setAuthError', data );
    },
    revertCode( { commit } ){

        commit( 'revertCode' );
        commit( 'setAuthError', '' );
    },
    clearState( { commit } ){

        commit( 'clearState' );
    }
};

const getters = {

    isAuth             : state => !!state.isAuth,
    activeRole         : state => state.activeRole,
    allRoles           : state => state.roles,
    profileInfo        : state => state.profileInfo, 
    profileUpdateError : state => state.profileUpdateError,
    authError          : state => state.authError,
    sentCode           : state => state.sentCode,
    phoneUser          : state => state.phoneUser,
    authViaPhone       : state => state.authViaPhone,
    phrase( state ){

        return ( state.isAuth ? state.isAuth.split( '.' )[ 0 ] : null );
    }
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
